import React from 'react';
import '../../css/components/Skeleton/Skeleton.css';

function ProductCardSkeleton() {
  return (
    <div className="Content__productCard categoriesProductCard skeleton-card" aria-hidden="true">
      <div className="Content__productCard--image">
        <div className="Content__productCard--image-mainImage activeImage">
          <div className="skeleton skeleton--image" />
        </div>
      </div>
      <div className="Content__productCard--details">
        <div className="Content__productCard--details-name">
          <div className="skeleton skeleton--line" style={{ width: '80%', height: '18px' }} />
        </div>
        <div className="Content__productCard--details-prices">
          <div className="Content__productCard--details-clubPrice">
            <div className="skeleton skeleton--line" style={{ width: '90px', height: '20px' }} />
            <div className="skeleton skeleton--line" style={{ width: '45px', height: '20px' }} />
          </div>
          <div className="Content__productCard--details-regularPrice">
            <div className="skeleton skeleton--line" style={{ width: '70px', height: '16px' }} />
          </div>
        </div>
        <div className="Content__productCard--actions">
          <div className="skeleton skeleton--line" style={{ width: '100%', height: '42px', borderRadius: '0' }} />
          <div className="skeleton skeleton--line" style={{ width: '100%', height: '42px', borderRadius: '0' }} />
        </div>
      </div>
    </div>
  );
}

export default ProductCardSkeleton;
